import { Box, Grid, StepIconProps, StepLabel, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { useStepState } from "../../contexts/steps/Reducer";

const MortgageStepMobileLabel = styled(Typography)(() => ({
    color: "#333333",
    fontSize: "18px",
    letterSpacing: 0,
    lineHeight: "26px",
    fontWeight: 300,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
}));

const MortgageStepMobileBoldLabel = styled(Typography)(() => ({
    color: "#333333",
    fontSize: "18px",
    letterSpacing: 0,
    lineHeight: "30px",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
}));

const MortgageStepperLabel = styled(StepLabel)({
    "& .MuiStepIcon-root.Mui-active": {
        color: "#0093D1",
    },
    "& .MuiStepIcon-root": {
        color: "rgba(0, 0, 0, 0.54)",
    },
    "& .MuiStepLabel-label.Mui-active": {
        fontWeight: 500,
    },
    "& .MuiStepLabel-label": {
        color: "#333333",
        fontFamily: "Yoga Sans",
        fontSize: "18px",
        letterSpacing: 0,
        lineHeight: "26px",
        fontWeight: 300,
    },
    "& .MuiStepIcon-text": {
        color: "#FFFFFF",
        fontSize: "18px",
    },
});

const StepperWrapper = styled(Box)(() => ({
    marginBottom: "23px",
}));

const CircleDiv = styled("div")({
    color: "#FFFFFF",
    fontSize: "18px",
    borderRadius: "50%",
    backgroundColor: "rgba(0, 0, 0, 0.54);",
    width: "24px",
    height: "24px",
    textAlign: "center",
    border: 0,
    userSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
});

function CustomStepIcon(props: StepIconProps) {
    const { icon, active } = props;
    return <CircleDiv sx={active ? { backgroundColor: "#0093D1" } : {}}>{icon}</CircleDiv>;
}

const MortgageStepper = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    const { step } = useStepState();

    const matchesWebView = useMediaQuery(theme.breakpoints.up("lg"));

    const stepLabels = [t("Actions.Extend mortgage"), t("General.Summary"), t("General.Confirmation")];

    const renderWebView = () => {
        return (
            <StepperWrapper>
                <Stepper nonLinear activeStep={step - 1}>
                    <Step key={1} data-cy={"extend-mortgage"}>
                        <MortgageStepperLabel StepIconComponent={CustomStepIcon}>
                            {t("Actions.Extend mortgage")}
                        </MortgageStepperLabel>
                    </Step>
                    <Step key={2} data-cy={"mortgage-summary"}>
                        <MortgageStepperLabel StepIconComponent={CustomStepIcon}>
                            {t("General.Summary")}
                        </MortgageStepperLabel>
                    </Step>
                    <Step key={3} data-cy={"confirmation"}>
                        <MortgageStepperLabel StepIconComponent={CustomStepIcon}>
                            {t("General.Confirmation")}
                        </MortgageStepperLabel>
                    </Step>
                </Stepper>
            </StepperWrapper>
        );
    };

    const renderMobileView = () => {
        return (
            <Box mb={"24px"}>
                <MortgageStepMobileLabel>
                    {t("General.Step of", {
                        numberStart: step,
                        numberEnd: 3,
                    })}
                </MortgageStepMobileLabel>
                <MortgageStepMobileBoldLabel>{stepLabels[step - 1]}</MortgageStepMobileBoldLabel>
            </Box>
        );
    };

    return (
        <Grid container data-cy={"stepper"}>
            <Grid item sm={0} md={1} lg={2}></Grid>
            <Grid item sm={12} md={10} lg={8}>
                {matchesWebView ? renderWebView() : renderMobileView()}
            </Grid>
            <Grid item sm={0} md={1} lg={2}></Grid>
        </Grid>
    );
};

export default MortgageStepper;
